import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defNeutralizeCountryName',
})
export class NeutralizeCountryNamePipe implements PipeTransform {

  readonly substringsToRemove = [', Province of China'];

  transform(value: any): any {
    return this.neutralizeCountryName(value);
  }

  private neutralizeCountryName(name: string): string {
    for (const toRemove of this.substringsToRemove) {
      if (name.includes(toRemove)) {
        return name.replace(toRemove, '');
      }
    }

    return name;
  }

}
